import { render } from "./login.vue?vue&type=template&id=ad5920a2&scoped=true&ts=true"
import script from "./login.vue?vue&type=script&lang=ts"
export * from "./login.vue?vue&type=script&lang=ts"

import "./login.vue?vue&type=style&index=0&id=ad5920a2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad5920a2"]])

export default __exports__